import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// --- Plantilla General ---
import MainTemplate from '../components/templates/MainTemplate';

// --- Componentes ---
import HomePage from '../components/pages/Home/Home';
import RoomDetail from '../components/pages/rooms/RoomDetail';
// ... importa tus otros componentes aquí ...
import RestauranteManglePage from '../components/pages/hotel/RestauranteMangle/RestauranteManglePage';
import MenuPage from '../components/pages/hotel/MenuPage/MenuPage';
import TrasladosPage from '../components/pages/hotel/Traslados/TrasladosPage';
import CenasRomanticasPage from '../components/pages/hotel/Experiencias/CenasRomanticas/CenasRomanticasPage';
import PropuestasMatrimonioPage from '../components/pages/hotel/Experiencias/PropuestasMatrimonio/PropuestasMatrimonioPage';
import WellnessPage from '../components/pages/hotel/Experiencias/Wellness/WellnessPage';
import BodasPage from '../components/pages/hotel/Eventos/Bodas/BodasPage';
import UbicacionPage from '../components/pages/holbox/Ubicacion/UbicacionPage';
import TipsPage from '../components/pages/holbox/Tips/TipsPage';
import ToursPage from '../components/pages/holbox/Tours/ToursPage';
import ContactoPage from '../components/pages/contacto/ContactoPage';
import PressPage from '../components/pages/Press/PressPage';
import FaqPage from '../components/pages/FAQ/FaqPage';
import GaleriaPage from '../components/pages/Galeria/GaleriaPage';
import ComparaHabitacionesPage from '../components/pages/rooms/ComparaHabitaciones/ComparaHabitaciones';
import EmployePage from '../components/pages/employe/EmployePage';
import ScrollToTop from '../components/atoms/ScrollToTop/ScrollToTop';
import { routeMap } from '../config/routes';

const SUPPORTED_LANGS = ['en', 'es'];

const AppRouter: React.FC = () => {
  const { i18n } = useTranslation();
  const detectedLangCode = i18n.language.split('-')[0];
  const currentLang = SUPPORTED_LANGS.includes(detectedLangCode) ? detectedLangCode : 'en';

  const RedirectToLang: React.FC = () => {
    const targetPath = routeMap.home[currentLang as 'en' | 'es'];
    return <Navigate to={`/${currentLang}/${targetPath}`} replace />;
  };

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<RedirectToLang />} />
        <Route path="/:lang" element={<RedirectToLang />} />

        {/* --- MENU PÚBLICO (Sin Layout) --- */}
        <Route path={`/en/${routeMap.menuMangle.en}`} element={<MenuPage />} />
        <Route path={`/es/${routeMap.menuMangle.es}`} element={<MenuPage />} />

        {/* --- LAYOUT PRINCIPAL --- */}
        <Route element={<MainTemplate />}>

          {/* =======================================================
              BLOQUE DE RUTAS EN INGLÉS (Prefijo /en/ forzado)
             ======================================================= */}
          <Route path={`/en/${routeMap.home.en}`} element={<HomePage />} />
          <Route path={`/en/${routeMap.roomDetail.en}`} element={<RoomDetail />} /> {/* /en/rooms/:slug */}
          <Route path={`/en/${routeMap.restauranteMangle.en}`} element={<RestauranteManglePage />} />
          <Route path={`/en/${routeMap.traslados.en}`} element={<TrasladosPage />} />
          <Route path={`/en/${routeMap.cenasRomanticas.en}`} element={<CenasRomanticasPage />} />
          <Route path={`/en/${routeMap.propuestasMatrimonio.en}`} element={<PropuestasMatrimonioPage />} />
          <Route path={`/en/${routeMap.wellness.en}`} element={<WellnessPage />} />
          <Route path={`/en/${routeMap.bodas.en}`} element={<BodasPage />} />
          <Route path={`/en/${routeMap.ubicacionHolbox.en}`} element={<UbicacionPage />} />
          <Route path={`/en/${routeMap.tipsHolbox.en}`} element={<TipsPage />} />
          <Route path={`/en/${routeMap.contacto.en}`} element={<ContactoPage />} />
          <Route path={`/en/${routeMap.press.en}`} element={<PressPage />} />
          <Route path={`/en/${routeMap.faq.en}`} element={<FaqPage />} />
          <Route path={`/en/${routeMap.toursHolbox.en}`} element={<ToursPage />} />
          <Route path={`/en/${routeMap.galeria.en}`} element={<GaleriaPage />} />
          <Route path={`/en/${routeMap.compareRooms.en}`} element={<ComparaHabitacionesPage />} />
          <Route path={`/en/${routeMap.employe.en}`} element={<EmployePage />} />


          {/* =======================================================
              BLOQUE DE RUTAS EN ESPAÑOL (Prefijo /es/ forzado)
             ======================================================= */}
          <Route path={`/es/${routeMap.home.es}`} element={<HomePage />} />
          <Route path={`/es/${routeMap.roomDetail.es}`} element={<RoomDetail />} /> {/* /es/habitaciones/:slug */}
          <Route path={`/es/${routeMap.restauranteMangle.es}`} element={<RestauranteManglePage />} />
          <Route path={`/es/${routeMap.traslados.es}`} element={<TrasladosPage />} />
          <Route path={`/es/${routeMap.cenasRomanticas.es}`} element={<CenasRomanticasPage />} />
          <Route path={`/es/${routeMap.propuestasMatrimonio.es}`} element={<PropuestasMatrimonioPage />} />
          <Route path={`/es/${routeMap.wellness.es}`} element={<WellnessPage />} />
          <Route path={`/es/${routeMap.bodas.es}`} element={<BodasPage />} />
          <Route path={`/es/${routeMap.ubicacionHolbox.es}`} element={<UbicacionPage />} />
          <Route path={`/es/${routeMap.tipsHolbox.es}`} element={<TipsPage />} />
          <Route path={`/es/${routeMap.contacto.es}`} element={<ContactoPage />} />
          <Route path={`/es/${routeMap.press.es}`} element={<PressPage />} />
          <Route path={`/es/${routeMap.faq.es}`} element={<FaqPage />} />
          <Route path={`/es/${routeMap.toursHolbox.es}`} element={<ToursPage />} />
          <Route path={`/es/${routeMap.galeria.es}`} element={<GaleriaPage />} />
          <Route path={`/es/${routeMap.compareRooms.es}`} element={<ComparaHabitacionesPage />} />
          <Route path={`/es/${routeMap.employe.es}`} element={<EmployePage />} />

        </Route>

        <Route path="*" element={<div>404 Not Found</div>} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;